module.exports = __webpack_public_path__ + "img/c1000.59a600c7.jpg";